import { GraphqlQueryResponse } from "@/Common/api/types/GraphqlQueryResponse";
import { apiInstance, gql } from "@/services/httpAdapter";
import { errorLogger } from "@/Common/helpers/logger";
import { ITechnicianFlaggedTimeResponse, ITechnicianFlaggedTimeBase } from "@/DataPages/types/technicianFlaggedTime/model";

export async function getTechnicianIsFinalized(locationId: string, commissionCycleId: string, payPeriodId: string) {
	const query = gql`
		query getTechnicianIsFinalized($locationId: String!, $commissionCycleId: String!, $payPeriodId: String!) {
			getTechnicianIsFinalized(locationId: $locationId, commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
				locationId
				commissionCycleId
				payPeriodId
				isFinalized
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		payPeriodId,
	};

	try {
		const response: GraphqlQueryResponse<"getTechnicianIsFinalized", ITechnicianFlaggedTimeBase> = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return response.data.data?.getTechnicianIsFinalized;
	} catch (err) {
		errorLogger(err as Error, {
			function: "getTechnicianIsFinalized",
			message: "Failed to get technician isFinalized",
			variables,
		});
		return null;
	}
}

export async function getTechnicianFlaggedTime(
	locationId: string,
	commissionCycleId: string,
	payPeriodId: string,
	first: number,
	after: string
) {
	const query = gql`
		query getTechnicianFlaggedTime(
			$locationId: String!
			$commissionCycleId: String!
			$payPeriodId: String!
			$pagination: PaginationInput!
		) {
			getTechnicianFlaggedTime(
				locationId: $locationId
				commissionCycleId: $commissionCycleId
				payPeriodId: $payPeriodId
				pagination: $pagination
			) {
				edges {
					node {
						_id
						locationId
						jobStatus
						commissionCycleId
						payPeriodId
						employeeId
						employeeName
						repairOrderNo
						hierarchy
						finishDate
						userId
						department
						operationCode
						startTime
						finishTime
						reason
						actualTime
						bookedTime
						techBookedTime
						rate
						extended
						job
						payrollStatus
						saleType
						isParent
						repairOrderCreationDate
						inStockDate
						purchaseDate
					}
					cursor
				}
				pageInfo {
					endCursor
					hasNextPage
				}
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		payPeriodId,
		pagination: {
			first,
			after,
		},
	};

	try {
		const response: GraphqlQueryResponse<"getTechnicianFlaggedTime", ITechnicianFlaggedTimeResponse> = await apiInstance.post(
			"/graphql",
			{
				query,
				variables,
			}
		);
		return response.data.data?.getTechnicianFlaggedTime;
	} catch (err) {
		errorLogger(err as Error, {
			function: "getTechnicianFlaggedTime",
			message: "Failed to get technician flagged time",
			variables,
		});
		return null;
	}
}
